import { useState } from "react";

import {
  Box,
  Card,
  CardMedia,
  Typography,
  Chip,
  Stack,
  Paper,
} from "@mui/material";

import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import VerifiedIcon from "@mui/icons-material/Verified";
import ScienceIcon from "@mui/icons-material/Science";
import ParkIcon from "@mui/icons-material/Park";

import GallerySection from "./GallerySection";

function HeroImage({ plant }) {
  const [selectedImage, setSelectedImage] = useState(plant.image);

  return (
    <Box mb={8}>
      {/* Hero */}

      <Card
        elevation={0}
        sx={{
          borderRadius: 6,
          overflow: "hidden",
          position: "relative",
          boxShadow: "0 15px 40px rgba(0,0,0,.12)",
        }}
      >
        <CardMedia
          component="img"
          image={selectedImage}
          alt={plant.common_name}
          sx={{
            width: "100%",
            height: {
              xs: 280,
              sm: 360,
              md: 450,
              lg: 520,
            },
            objectFit: "cover",
            transition: ".4s",

            "&:hover": {
              transform: "scale(1.03)",
            },
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,.35), transparent 60%)",
          }}
        />

        <Chip
          icon={<ParkIcon />}
          label="Rayalaseema University Digital Flora"
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            bgcolor: "#ffffffee",
            color: "#0B3C5D",
            fontWeight: 700,
          }}
        />
      </Card>

      {/* Glass Card */}

      <Paper
        elevation={0}
        sx={{
          mt: "10px",
          mx: "auto",
          width: {
            xs: "96%",
            md: "90%",
            lg: "84%",
          },

          p: {
            xs: 3,
            md: 5,
          },

          borderRadius: 6,

          background:
            "linear-gradient(135deg,#ffffff,#F7FCF8)",

          boxShadow: "0 10px 35px rgba(0,0,0,.08)",

          textAlign: "center",
        }}
      >
        <Typography
          fontWeight={800}
          color="#0B3C5D"
          fontSize={{
            xs: "2rem",
            md: "3rem",
          }}
        >
          {plant.common_name}
        </Typography>

        <Typography
  mt={1}
  color="#666"
  fontSize={{
    xs: "1rem",
    md: "1.3rem",
  }}
>
  <Typography
    component="span"
    sx={{
      fontStyle: "italic",
    }}
  >
    {plant.scientific_name}
  </Typography>

  {(plant.aname || plant.botanical_profile?.aname) && (
    <Typography
      component="span"
      sx={{
        ml: 0.5,
        fontStyle: "normal",
      }}
    >
      {plant.aname || plant.botanical_profile?.aname}
    </Typography>
  )}
</Typography>

        <Typography mt={1}>
          <strong>Local Name :</strong> {plant.local_name}
        </Typography>

        <Typography mt={1} color="text.secondary">
          Department of Botany • School of Life Sciences
        </Typography>

        <Box
          sx={{
            width: 80,
            height: 4,
            bgcolor: "#43A047",
            mx: "auto",
            my: 3,
            borderRadius: 5,
          }}
        />

        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          flexWrap="wrap"
          useFlexGap
        >
          <Chip
  icon={<LocalFloristIcon />}
  label={`Family : ${
    plant.family ||
    plant.botanical_profile?.family ||
    plant.taxonomic_classification?.family ||
    "Not Available"
  }`}
  color="success"
/>

          <Chip
            icon={<VerifiedIcon />}
            label={plant.conservation_status.iucn_status}
            color="primary"
          />

          <Chip
  icon={<ScienceIcon />}
  label={`IUCN : ${
    plant.conservation_status?.IUCN_status || "Not Evaluated"
  }`}
  color="warning"
/>

{/* <Chip
  icon={<ScienceIcon />}
  label={`Assessment : ${
    plant.conservation_status?.assessment_year || "Not Available"
  }`}
  color="warning"
/> */}
        </Stack>
      </Paper>

      {/* Gallery */}

      <GallerySection
        plant={plant}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
      />
    </Box>
  );
}

export default HeroImage;